import React, { useEffect, useState } from "react";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function GroupField({ groups, value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateNotEmpty(value, 'group');
        return () => validationService.cleanValidation('group');
    }, [value]);

    const [touched, setTouched] = useState(false);

    const handleChange = (id) => {
        const group = groups.find((group) => String(group.id) === String(id));
        onChange(group);
        setTouched(true);
    };

    const groupOptions = sortObjectsByAlphabet(groups || [], "name").map((group) => ({
        value: group.id,
        label: group.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="group">Group <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="group"
                    className={(error && touched) ? "border-danger" : ""}
                    value={value ?? ""}
                    onChange={handleChange}
                    options={groupOptions}
                    isDisabled={disabled}
                    placeholder="Select group"
                    noOptionsMessage={() => "No groups found"}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("GroupField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.group
    };
}

export default connect(mapStateToProps)(GroupField);
